<template>
  <v-flex
    d-flex
    xs6
    sm3
    md3
    lg2
    :title="product.name"
    style="position: relative"
    @click.stop="openModal"
  >
    <div
      v-if="['foodguru'].includes(pageProfile.type)"
      style="position: absolute; top: 8px; left: 8px; z-index: 1"
    >
      <v-checkbox
        :on-icon="'mdi-star'"
        :off-icon="'mdi-star'"
        color="#FFD700"
        v-model="product.favorite"
        v-bind:value="isProductFav"
        @change="onFavProduct(product.id, product.favorite)"
        class="btn-fav"
      >
      </v-checkbox>
    </div>
    <v-card style="cursor: pointer" height="100%">
      <div class="soldout-tag" v-if="isOutOfStock">
        <div class="text">
          {{ $t('Sold Out') }}
          <v-btn
            v-if="pageProfile.type == 'reka'"
            small
            color="white"
            @click.prevent="onSendMessage"
          >
            Pre-order กับแอดมิน
          </v-btn>
        </div>
      </div>
      <div
        class="soldout-tag"
        v-if="isTremendous && isMemberNotPledgeWaterTank"
      >
        <div class="text">
          {{ $t('please_pledge_water_tank') }}
        </div>
      </div>
      <div class="soldout-tag" v-if="isTremendous && isDisabledProduct">
        <!-- <div class="text">
          {{ $t('please_pledge_water_tank') }}
        </div> -->
      </div>
      <div>
        <v-responsive
          :aspect-ratio="1"
          style="background-position: center; background-size: cover"
        >
          <!-- <div
            style="background-color: #eee;height: 100%;background-position: center;background-size: cover;"
            :style="{ backgroundImage: 'url(\'' + productImages[0] + '\'),url(\''+require('@/assets/img/products/default-photo.png')+'\')' }"
          ></div> -->

          <v-img
            v-if="productImages[0]"
            :src="productImages[0]"
            :lazy-src="`@/assets/img/products/default-photo.png`"
            aspect-ratio="1"
            class="white"
          >
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-layout> </template
          ></v-img>
          <v-img
            v-else
            :src="`@/assets/img/products/default-photo.png`"
            aspect-ratio="1"
            class="white"
          >
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-layout> </template
          ></v-img>
        </v-responsive>
        <!-- <v-img :src="productImages[0]" aspect-ratio="1" :alt="product.name" lazy-src></v-img> -->
      </div>

      <div
        class="text-xs-center sale-tag caption"
        v-if="discountPercentage > 0 && !['nvbb'].includes(pageProfile.type)"
        style="position: absolute; right: 5px; top: 0"
      >
        {{ $t('Sale') }}
        <br />
        {{ discountPercentage | numberFormat }}%
      </div>

      <v-card-title primary-title class="pt-3">
        <div>
          <div class="caption mb-2 mt-0">{{ product.name }}</div>
          <div class="body-1 mb-1" :style="{ color: theme.color }">
            <template v-if="discountPriceRange != priceRange">{{
              discountPriceRange
            }}</template>
            <template v-else>{{ priceRange }}</template>
          </div>
          <div class="caption discount" v-if="discountPriceRange != priceRange">
            {{ priceRange }}
          </div>
          <div class="caption" v-else>&nbsp;</div>
        </div>

        <template v-if="['nestle'].includes(pageProfile.type)">
          <CheckBundle :product="product" />
          <div style="height: 40px; width: 100%"></div>
        </template>
      </v-card-title>
      <template v-if="['nestle'].includes(pageProfile.type)">
        <div
          style="
            display: block;
            width: 100%;
            position: absolute;
            bottom: 10px;
            right: 10px;
          "
          class="text-xs-right"
        >
          <v-btn icon small color="primary" @click.stop="handleQuickAddCart">
            <v-icon small>mdi-cart</v-icon>
          </v-btn>
        </div>
      </template>
    </v-card>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex'

import ModalProduct from '@/components/ecommerce/ModalProduct.vue'
import Modal from '@/components/Modal.vue'
import ModalImage from '@/components/ModalImage.vue'
import config from '@/config'
import axios from 'axios'
import numeral from 'numeral'
import { Carousel, Slide } from 'vue-carousel'
import Nl2br from 'vue-nl2br'
import { VueperSlide, VueperSlides } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

import CheckBundle from './Bundles/CheckBundle'

import {
  bearhousebubbletea,
  bearhousepackagehasbubble
} from '@/assets/js/BearHouse.js'
import vZoom from 'vue-zoom'

export default {
  props: ['value', 'products'],
  data() {
    return {
      product: this.value,
      showModal: false,
      showAlert: false,
      showPreview: false,
      currentPreview: null,
      quantity: 1,
      stock: [],
      option: null,
      selectedImage: null,
      loadingProduct: true,
      productbundle: [],
      isImageFail: false,
      isProductFav: false
    }
  },
  computed: {
    ...mapGetters({
      cart: 'getCart',
      isWholesale: 'getWholesaleStatus',
      wholesale: 'getWholesale',
      theme: 'getTheme',
      pageProfile: 'getPageProfile'
    }),
    currencySign: function () {
      if (this.product && this.product.currency) {
        return this.getCurrencyByCode(this.product.currency)
      }
      return '฿'
    },
    productImages: function () {
      let images = []
      if (this.product && this.product.photourl) {
        try {
          images = this.product.photourl.split(';;')
        } catch (error) {
          //
        }
        // this.previewImage =
        //   images.length > 0
        //     ? images[0]
        //     : "../assets/img/ecommerce/product_image_fallback@2x.png";
      }
      return images
    },
    filterCart() {
      return this.cart
    },
    isMemberNotPledgeWaterTank() {
      if (this.isTremendous) {
        if (this.product && this.product.name === 'น้ำถังใส 18.9') {
          if (!this.tremendousMemberInfo) {
            return true
          } else if (
            this.tremendousMemberInfo &&
            (!this.tremendousMemberInfo.total_pledge_water_tank ||
              this.tremendousMemberInfo.total_pledge_water_tank == '0')
          ) {
            return true
          } else {
            return false
          }
        }
      }

      return false
    },
    isDisabledProduct() {
      if (this.isTremendous) {
        if (this.filterCart && this.filterCart.length > 0) {
          const findPledgeWaterTankProduct = this.filterCart.findIndex(
            (item) =>
              item.name === 'มัดจำถังน้ำ 18.9 ลิตร 1ถัง/100บาท' ||
              item.name === 'มัดจำถังน้ำ 1'
          )

          if (findPledgeWaterTankProduct > -1) {
            if (
              this.product.name !== 'มัดจำถังน้ำ 18.9 ลิตร 1ถัง/100บาท' &&
              this.product.name !== 'มัดจำถังน้ำ 1'
            ) {
              return true
            }
          } else {
            if (
              this.product.name === 'มัดจำถังน้ำ 18.9 ลิตร 1ถัง/100บาท' ||
              this.product.name === 'มัดจำถังน้ำ 1'
            ) {
              return true
            }
          }
        }
      } else {
        return false
      }
    },
    isOutOfStock: function () {
      let vm = this
      if (vm.option) {
        if (parseInt(vm.option[2]) <= 0) {
          return true
        }
        if (parseInt(vm.option[2]) < vm.quantity) {
          return true
        }
        return false
      }
      return true
    },
    priceRange: function () {
      var min = 0
      var max = 0

      if (this.product.productstock.length <= 0) {
        min = this.product.price
        max = this.product.price
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            min = this.product.productstock[index][3]
            max = this.product.productstock[index][3]
          } else {
            if (this.product.productstock[index][3] > max) {
              max = this.product.productstock[index][3]
            }
            if (this.product.productstock[index][3] < min) {
              min = this.product.productstock[index][3]
            }
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    },
    discountPriceRange: function () {
      var min = 0
      var max = 0

      if (this.product.productstock.length <= 0) {
        min = this.product.discountprice
        max = this.product.discountprice
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            min = this.product.productstock[index][4]
            max = this.product.productstock[index][4]
          } else {
            if (this.product.productstock[index][4] > max) {
              max = this.product.productstock[index][4]
            }
            if (this.product.productstock[index][4] < min) {
              min = this.product.productstock[index][4]
            }
          }
        }
      }

      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    },
    discountPercentage: function () {
      var max = 0

      if (this.product.productstock.length <= 0) {
        max =
          ((this.product.price - this.product.discountprice) /
            this.product.price) *
          100
      } else {
        for (let index = 0; index < this.product.productstock.length; index++) {
          if (index == 0) {
            max =
              ((this.product.productstock[index][3] -
                this.product.productstock[index][4]) /
                this.product.productstock[index][3]) *
              100
          } else {
            var percent =
              ((this.product.productstock[index][3] -
                this.product.productstock[index][4]) /
                this.product.productstock[index][3]) *
              100
            if (max < percent) {
              max = percent
            }
          }
        }
      }

      return max
    },
    totalBundle: function () {
      var vm = this
      var quantity = 0
      if (vm.isWholesale) {
        if (vm.cart) {
          vm.cart.map(function (product) {
            quantity += product.quantity
          })
        }
        return quantity
      }
      var products = vm.cart.filter(function (product) {
        return product.id == vm.product.id
      })
      quantity = 0
      products.map((p) => {
        quantity += p.quantity
      })
      return quantity
    },
    productstock: function () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.product.productstock
      // .sort(function(a, b) {
      //   if (a[6] > b[6]) {
      //     return 1;
      //   } else if (a[6] < b[6]) {
      //     return -1;
      //   } else {
      //     return 0;
      //   }
      // });
    },
    isBearhouse() {
      return (
        this.pageProfile &&
        this.$store.state.bearhouse.includes(this.pageProfile.pageid)
      )
    },
    bubbletea() {
      return bearhousebubbletea(this.products)
    },
    hasBubbleTea() {
      return bearhousepackagehasbubble().includes(this.product.id)
    },
    isTremendous() {
      return this.pageProfile && this.pageProfile.type === 'tremendous'
    },
    tremendousMemberInfo() {
      return this.$store.state.tremendousMemberInfo
    }
  },
  components: {
    vZoom,
    ModalProduct,
    Modal,
    ModalImage,
    VueperSlides,
    VueperSlide,
    Nl2br,
    Carousel,
    Slide,
    CheckBundle
  },
  watch: {
    value: function () {
      let vm = this
      this.product = this.value
      //   this.getStock()
      if (this.productImages.length > 0) {
        this.selectedImage = this.productImages[0]
      }

      vm.setOption()
    },
    showModal: function (newVal) {
      if (newVal) {
        this.addClass('body', 'modal-open')
      } else {
        this.removeClass('body', 'modal-open')
      }
    }
  },
  created: function () {},
  mounted: function () {
    // this.getStock()
    let vm = this
    if (this.productImages.length > 0) {
      this.selectedImage = this.productImages[0]
    }

    if (this.$route.query.pid) {
      var pid = this.$route.query.pid
      var productid = pid
      // console.log(productid, this.product.id.toString());
      if (productid === this.product.id.toString()) this.openModal()
    }
    vm.setOption()

    vm.loadingProduct = false
  },
  methods: {
    async handleQuickAddCart() {
      const vm = this

      const quantity = 1
      const addcarttype = 'addandcheckout'
      const isClose = ['addandclose', 'addandcheckout'].includes(addcarttype)

      let option = null
      if (
        vm.product &&
        vm.product.productstock &&
        vm.product.productstock.length
      ) {
        try {
          option = vm.product.productstock[0]
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        }
      } else {
        return null
      }
      if (option) {
        const price = option[3]
        const discountprice = option[4]
        let item = {
          quantity: quantity,
          option: option,
          buttonaction: vm.product.buttonaction,
          buttonname: vm.product.buttonname,
          buttonurl: vm.product.buttonurl,
          categoryid: vm.product.categoryid,
          currency: vm.product.currency,
          description: vm.product.description,
          id: vm.product.id,
          keyword: vm.product.keyword,
          name: vm.product.name,
          pageid: vm.product.pageid,
          photohash: vm.product.photohash,
          photourl: option[7] ? option[7] : vm.product.photourl,
          price: price,
          priority: vm.product.priority,
          subcategoryid: vm.product.subcategoryid,
          discountprice: discountprice,
          productbundle: [],
          cart_remark: '',
          weight: vm.product.weight ? vm.product.weight : 0,
          // eslint-disable-next-line no-undef
          addon_json: {},
          producttype: vm.product.producttype
        }

        vm.$emit('addToCart', {
          item: item,
          loading: function () {
            if (vm.pageProfile.type != 'chillpainai') {
              if (isClose) {
                if (['addandcheckout'].includes(addcarttype)) {
                  vm.$emit('openCheckout')
                } else {
                  vm.closeWindow()
                }
              } else {
                // vm.snackbar = true;
              }
            }
            // vm.loading = false
          }
        })
      }
    },
    async onSendMessage() {
      let text = 'ต้องการ pre-order สินค้า ' + this.product.name
      if (this.$liff.isInClient()) {
        // eslint-disable-next-line no-undef
        await this.$liff.sendMessages([
          {
            type: 'text',
            text: text
          }
        ])
        // eslint-disable-next-line no-undef
        this.$liff.closeWindow()
      } else {
        window.location.href =
          'https://m.me/' + this.pageProfile.pageid + '?ref=contactadmin'
      }
    },
    getProductBundle: function (callback) {
      let vm = this
      let url =
        config.getConfig('serverUrl') +
        'productbundle?productid=' +
        vm.product.id
      axios.get(url).then((response) => {
        response = response.data
        if (response.responsecode == 200) {
          vm.productbundle = response.productbundlelist
          callback()
        } else {
          callback()
        }
      })
    },
    onPreviewImgError: function () {
      this.isImageFail = true
      //  this.previewImage = "../assets/img/ecommerce/product_image_fallback@2x.png"
    },
    setOption: function () {
      let vm = this
      if (
        vm.product &&
        vm.product.productstock &&
        vm.product.productstock.length > 0
      ) {
        vm.option = null
        let option = vm.productstock.find((val) => parseInt(val[2]) > 0)
        if (option) vm.option = option
      } else {
        vm.option = null
      }
    },
    openModal: function () {
      if (!this.isDisabledProduct && !this.isMemberNotPledgeWaterTank) {
        this.$emit('selectProduct')
      }

      // this.showModal = true;
      // // eslint-disable-next-line
      // let vm = this;
      // vm.getProductBundle(function() {});
      // window.location.hash = "#modal-open";
      // window.onpopstate = function() {
      //   if (location.hash != "#modal-open") {
      //     vm.showModal = false;
      //   }
      // };
    },
    close: function () {
      let vm = this
      if (window.history.length == 0) {
        vm.showModal = false
      } else {
        // window.history.back();
      }
    },
    addCount: function () {
      if (!this.option || this.option == null) {
        return false
      }
      if (this.quantity < this.option[2]) {
        this.quantity++
      }
    },
    removeCount: function () {
      if (this.quantity > 1) {
        this.quantity--
      }
    },

    getStock: function () {
      let vm = this
      axios
        .get(
          config.getConfig('serverUrl') +
            'productstock?productid=' +
            vm.product.id
        )
        .then((response) => {
          // JSON responses are automatically parsed.
          response = response.data
          if (response.responsecode == 200) {
            vm.stock = response.productstocklist
            vm.setOption()
          } else {
            // console.log(response);
          }
        })
    },
    onFavProduct: function (id, status) {
      // alert(event)
      let vm = this
      var data = {
        pageid: vm.product.pageid,
        userid: vm.$route.query.userid,
        productid: id,
        favorite: status
      }

      // console.log(data);

      let url = config.getConfig('serverUrl') + 'foodguru/favoriteProductById'
      axios.post(url, data).then((response) => {
        if (response.data.responsecode == 200) {
          // console.log(response);
          return true
        } else {
          this.$swal({
            title: this.$t('Error'),
            text: this.$t('Something went wrong. Please try it again.'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('Cancel'),
            reverseButtons: true
          })
          vm.$liff.closeWindow()
        }
      })
    }
  }
}
</script>

<style lang="scss">
.btn-fav {
  padding: 0 !important;
  margin: 0 !important;

  .v-input--selection-controls {
    padding: 0 !important;
    margin: 0 !important;
  }
}
</style>
